import { AutogenModelPartialShipmentControl, AutogenRowPartialShipmentControl } from "./autogen/AutogenModelPartialShipmentControl";

export class ModelPartialShipmentControl extends AutogenModelPartialShipmentControl<RowPartialShipmentControl> {
	constructor() {
		super(RowPartialShipmentControl);
	}
}

export class RowPartialShipmentControl extends AutogenRowPartialShipmentControl {
}